import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installFrontendErrorCapture } from "@/lib/errorCapture";

// Iter 103 — Install browser-side error hooks BEFORE React renders so
// even a hard boot crash lands in system_logs.
installFrontendErrorCapture();

// Swallow the benign "ResizeObserver loop" warning so CRA's dev error overlay
// doesn't cover the UI (commonly triggered by Recharts ResponsiveContainer).
const _roMsg = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(_roMsg)) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (overlay) overlay.style.display = "none";
  }
});

// Apply persisted theme before render to avoid flash (supports light | dark | system)
const _t = localStorage.getItem("theme") || "system";
if (_t === "dark" || (_t === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
  document.documentElement.classList.add("dark");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
